import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Badge,
  Spinner,
} from "reactstrap";
import {
  listofDeliveryBoy,
  foodOrderList,
  AssignDeliveryBoy,
  ReAssignDeliveryBoy,
  OrderListbyId,
  OrderFullfilled,
  OrderList,
  updatepaymentstatus,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { AvForm } from "availity-reactstrap-validation";

class FoodOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DBoyData: [],
      isLoaded: false,
      modal: false,
      Dboy: "",
      foodorderId: "",
      isRejected: "",
      // Pagination
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 15,
      search: "",
      // Order detail modal
      showOrderDetail: false,
      selectedOrder: null,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Food Orders", link: "#" },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      foodorderId: "",
      Dboy: "",
      isRejected: "",
    });
  }

  handleCloseModal() {
    this.setState({ modal: false });
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  listDeliveryBoy() {
    listofDeliveryBoy()
      .then((result) => {
        this.setState({ DBoyData: result?.data || [] });
      })
      .catch((error) => console.error(error));
  }

  getALllorder(page = this.state.currentPage, search = this.state.search) {
    const { limit } = this.state;
    this.setState({ isLoaded: false });

    OrderList(page, limit, search)
      .then((result) => {
        const pagination = result?.pagination || {};
        this.setState({
          isLoaded: true,
          items: result?.data || [],
          currentPage: pagination.currentPage || 1,
          totalPages: pagination.totalPages || 1,
          totalCount: pagination.totalCount || 0,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoaded: true, items: [] });
      });
  }

  // View order detail
  viewOrderDetail = (order) => {
    this.setState({
      showOrderDetail: true,
      selectedOrder: order,
    });
  };

  closeOrderDetail = () => {
    this.setState({
      showOrderDetail: false,
      selectedOrder: null,
    });
  };

  // Get order status badge
  getStatusBadge = (order) => {
    if (order.isCancelled) return <Badge color="danger">Cancelled</Badge>;
    if (order.isDelivered) return <Badge color="success">Delivered</Badge>;
    if (order.isDeliveryBoyAssigned) return <Badge color="info">Out for Delivery</Badge>;
    if (order.isOrderAccpeted) return <Badge color="primary">Accepted</Badge>;
    if (order.isOrderPlaced) return <Badge color="warning">Placed</Badge>;
    return <Badge color="secondary">Pending</Badge>;
  };

  // Get payment badge
  getPaymentBadge = (order) => {
    if (order.isPaymentSuccess) return <Badge color="success">Paid</Badge>;
    return <Badge color="warning">Pending</Badge>;
  };

  // Get order type label
  getOrderTypeLabel = (type) => {
    switch (type) {
      case 1: return "Room Service";
      case 2: return "Dine-in";
      case 3: return "Pickup";
      case 4: return "Delivery";
      default: return "N/A";
    }
  };

  OrderManagement(id, isRejected) {
    OrderListbyId(id)
      .then((results) => {
        this.setState({
          foodorderId: results.data._id,
          isRejected: results.data.isRejected,
        });
      })
      .catch(() => toast.error("Error fetching order"));
    this.toggle();
  }

  OrderFullFill(id) {
    OrderFullfilled(id)
      .then((results) => {
        if (results.status === 200) {
          toast.success(results.message);
          this.getALllorder();
        } else {
          toast.error(results.message);
        }
      })
      .catch(() => toast.error("Error completing order"));
  }

  StatusChangeRequest(id, isPaymentSuccess) {
    const data = { orderId: id, isPaymentSuccess };
    updatepaymentstatus(data)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
        this.getALllorder();
      })
      .catch(() => toast.error("Error updating payment status"));
  }

  handleSubmit(e) {
    e.preventDefault();
    const Data = {
      DboyuserId: this.state.Dboy,
      foodorderId: this.state.foodorderId,
    };

    const apiCall = this.state.isRejected === false ? AssignDeliveryBoy : ReAssignDeliveryBoy;

    apiCall(Data)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          this.getALllorder();
          this.listDeliveryBoy();
          this.handleCloseModal();
        } else {
          toast.error(response.message);
        }
      })
      .catch(() => toast.error("Error assigning delivery boy"));
  }

  componentDidMount() {
    this.getALllorder();
    this.listDeliveryBoy();
  }

  // Render action buttons for an order
  renderActionButton = (order) => {
    if (order.isCancelled) return <span className="text-muted">-</span>;

    if (order.orderPlacetype === 4) {
      // Delivery orders
      if (order.isDelivered) return <span className="text-success">Completed</span>;
      if (!order.isDeliveryBoyAssigned) {
        return (
          <Button
            color="primary"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              this.OrderManagement(order._id, order.isRejected);
            }}
          >
            {order.isRejected ? "Reassign" : "Assign"}
          </Button>
        );
      }
      return <span className="text-info">Assigned</span>;
    } else {
      // Non-delivery orders
      if (order.isDelivered) return <span className="text-success">Completed</span>;
      return (
        <Button
          color="success"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            this.OrderFullFill(order._id);
          }}
        >
          Complete
        </Button>
      );
    }
  };

  render() {
    const { items, isLoaded, currentPage, totalPages, totalCount, limit, search, selectedOrder } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Food Orders" breadcrumbItems={this.state.breadcrumbItems} />

            {/* Assign Delivery Boy Modal */}
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader toggle={this.toggle}>
                Assign Delivery Boy
              </ModalHeader>
              <ModalBody>
                <AvForm onValidSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label>Select Delivery Boy</Label>
                    <Input
                      type="select"
                      name="Dboy"
                      id="Dboy"
                      value={this.state.Dboy}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Delivery Boy</option>
                      {(this.state.DBoyData || []).map((e, key) => (
                        <option key={key} value={e._id}>
                          {e.firstName} {e.lastName}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <div className="text-center mt-4">
                    <Button color="primary">Assign</Button>
                  </div>
                </AvForm>
              </ModalBody>
            </Modal>

            {/* Order Detail Modal */}
            <Modal
              isOpen={this.state.showOrderDetail}
              toggle={this.closeOrderDetail}
              size="lg"
              scrollable
            >
              <ModalHeader toggle={this.closeOrderDetail} className="bg-primary text-white">
                <i className="ri-receipt-line mr-2"></i> Order Details
              </ModalHeader>
              <ModalBody className="p-0">
                {selectedOrder && (
                  <div>
                    {/* Status Header */}
                    <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="mb-1">
                          {selectedOrder.orderNumber || `#${selectedOrder._id?.slice(-6).toUpperCase()}`}
                        </h5>
                        <small className="text-muted">{selectedOrder.createdAt}</small>
                      </div>
                      <div>
                        {this.getStatusBadge(selectedOrder)}
                        <span className="mx-2">|</span>
                        {this.getPaymentBadge(selectedOrder)}
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-user-line mr-1"></i> Customer
                      </h6>
                      <Row>
                        <Col md={6}>
                          <p className="mb-1"><strong>Name:</strong> {selectedOrder.username || "N/A"}</p>
                          <p className="mb-0"><strong>Email:</strong> {selectedOrder.email || "N/A"}</p>
                        </Col>
                        <Col md={6}>
                          <p className="mb-1"><strong>Phone:</strong> {selectedOrder.mobile || "N/A"}</p>
                          <p className="mb-0"><strong>Type:</strong> {this.getOrderTypeLabel(selectedOrder.orderPlacetype)}</p>
                        </Col>
                      </Row>
                      {selectedOrder.deliveryAddress && (
                        <p className="mb-0 mt-2"><strong>Address:</strong> {selectedOrder.deliveryAddress}</p>
                      )}
                    </div>

                    {/* Order Items */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-restaurant-line mr-1"></i> Order Items
                      </h6>
                      <Table size="sm" className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Item</th>
                            <th className="text-center">Qty</th>
                            <th className="text-right">Price</th>
                            <th className="text-right">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedOrder.foodItems || []).map((item, index) => {
                            // Get per-unit price (after item discount)
                            const unitPrice = item.foodId?.finalAmount || (item.finalAmount / (item.quantity || 1)) || 0;
                            // Calculate item total from stored cartTotal (includes add-ons) or calculate
                            const itemTotal = item.cartTotal || (unitPrice * (item.quantity || 1));
                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{item.foodName || item.foodId?.foodName || "Food Item"}</td>
                                  <td className="text-center">{item.quantity || 1}</td>
                                  <td className="text-right">${unitPrice.toFixed(2)}</td>
                                  <td className="text-right">${itemTotal.toFixed(2)}</td>
                                </tr>
                                {/* Show add-ons for this item */}
                                {item.addOns && item.addOns.length > 0 && item.addOns.map((addOn, addOnIndex) => (
                                  <tr key={`addon-${index}-${addOnIndex}`} style={{ backgroundColor: '#f8f9fa' }}>
                                    <td className="pl-4" style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                      <i className="ri-add-line mr-1"></i>
                                      {addOn.foodAddOnName || 'Add-on'}
                                    </td>
                                    <td className="text-center" style={{ fontSize: '12px' }}>x{addOn.value || 1}</td>
                                    <td className="text-right" style={{ fontSize: '12px' }}>${(addOn.foodAddOnAmount || 0).toFixed(2)}</td>
                                    <td className="text-right" style={{ fontSize: '12px' }}>
                                      +${((addOn.foodAddOnAmount || 0) * (addOn.value || 1)).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                      {/* Show order-level add-ons if any */}
                      {selectedOrder.foodAddOn && selectedOrder.foodAddOn.length > 0 && (
                        <div className="mt-2 pt-2 border-top">
                          <small className="text-muted">Order Add-ons:</small>
                          {selectedOrder.foodAddOn.map((addOn, index) => (
                            <div key={index} className="d-flex justify-content-between">
                              <small>{addOn.foodAddOns?.foodAddOnName || 'Add-on'} x{addOn.value || 1}</small>
                              <small>+${((addOn.foodAddOns?.amount || 0) * (addOn.value || 1)).toFixed(2)}</small>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Special Instructions */}
                    {selectedOrder.instructions && (
                      <div className="p-3 border-bottom bg-light">
                        <h6 className="text-muted mb-1">
                          <i className="ri-chat-3-line mr-1"></i> Instructions
                        </h6>
                        <p className="mb-0 font-italic">"{selectedOrder.instructions}"</p>
                      </div>
                    )}

                    {/* Payment Summary */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-money-dollar-circle-line mr-1"></i> Payment
                      </h6>
                      {(() => {
                        // Use stored subtotal (includes add-ons) or calculate from cartTotal
                        let subtotal = selectedOrder.subtotal || 0;

                        // If no stored subtotal, calculate from item cartTotals (includes add-ons)
                        if (!subtotal) {
                          subtotal = (selectedOrder.foodItems || []).reduce((sum, item) => {
                            return sum + (item.cartTotal || 0);
                          }, 0);
                        }

                        // Fallback: calculate from unit prices (without add-ons) for very old orders
                        if (!subtotal) {
                          subtotal = (selectedOrder.foodItems || []).reduce((sum, item) => {
                            const unitPrice = item.foodId?.finalAmount || (item.finalAmount / (item.quantity || 1)) || 0;
                            return sum + (unitPrice * (item.quantity || 1));
                          }, 0);
                        }

                        const couponDiscount = selectedOrder.couponDiscount || 0;
                        // Use stored total if available, otherwise calculate
                        const total = selectedOrder.total !== undefined && selectedOrder.total !== null
                          ? selectedOrder.total
                          : (subtotal - couponDiscount);

                        return (
                          <Row>
                            <Col>
                              <p className="mb-1">Subtotal: <strong>${subtotal.toFixed(2)}</strong></p>
                              {selectedOrder.couponCode && (
                                <p className="mb-1 text-success">
                                  Discount ({selectedOrder.couponCode}): -${couponDiscount.toFixed(2)}
                                </p>
                              )}
                              <p className="mb-1">
                                <strong className="text-primary" style={{ fontSize: "1.2rem" }}>
                                  Total: ${total.toFixed(2)}
                                </strong>
                              </p>
                              <p className="mb-0">
                                Payment: {selectedOrder.paymentMethodType === 1 || selectedOrder.paymentMethodType === "Cash" ? "Cash" : "Online"}
                              </p>
                            </Col>
                          </Row>
                        );
                      })()}
                    </div>

                    {/* Cancellation Info */}
                    {selectedOrder.isCancelled && (
                      <div className="p-3 bg-danger text-white">
                        <h6 className="mb-1"><i className="ri-close-circle-line mr-1"></i> Cancelled</h6>
                        <p className="mb-0">Reason: {selectedOrder.cancellationReason || "No reason provided"}</p>
                      </div>
                    )}
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                {selectedOrder && !selectedOrder.isCancelled && !selectedOrder.isDelivered && (
                  <>
                    {!selectedOrder.isPaymentSuccess && (
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => {
                          this.StatusChangeRequest(selectedOrder._id, false);
                          this.closeOrderDetail();
                        }}
                      >
                        Mark Paid
                      </Button>
                    )}
                    {selectedOrder.orderPlacetype === 4 && !selectedOrder.isDeliveryBoyAssigned && (
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          this.closeOrderDetail();
                          this.OrderManagement(selectedOrder._id, selectedOrder.isRejected);
                        }}
                      >
                        Assign Delivery
                      </Button>
                    )}
                    {selectedOrder.orderPlacetype !== 4 && (
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => {
                          this.OrderFullFill(selectedOrder._id);
                          this.closeOrderDetail();
                        }}
                      >
                        Complete Order
                      </Button>
                    )}
                  </>
                )}
                <Button color="secondary" size="sm" onClick={this.closeOrderDetail}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>

            {/* Main Content */}
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    {/* Header with Search */}
                    <Row className="mb-3 align-items-center">
                      <Col md={6}>
                        <div className="d-flex">
                          <Input
                            type="text"
                            placeholder="Search orders..."
                            value={search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") this.getALllorder(1, search);
                            }}
                            style={{ maxWidth: "250px" }}
                          />
                          <Button
                            color="primary"
                            className="ml-2"
                            onClick={() => this.getALllorder(1, search)}
                          >
                            Search
                          </Button>
                          {search && (
                            <Button
                              color="light"
                              className="ml-2"
                              onClick={() => {
                                this.setState({ search: "" }, () => this.getALllorder(1, ""));
                              }}
                            >
                              Clear
                            </Button>
                          )}
                        </div>
                      </Col>
                      <Col md={6} className="text-right">
                        <span className="text-muted">
                          {totalCount} orders total
                        </span>
                      </Col>
                    </Row>

                    {/* Orders Table - Compact */}
                    {!isLoaded ? (
                      <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-2 text-muted">Loading orders...</p>
                      </div>
                    ) : items.length === 0 ? (
                      <div className="text-center py-5">
                        <i className="ri-inbox-line" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                        <p className="mt-2 text-muted">No orders found</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <Table hover className="mb-0" style={{ fontSize: "13px" }}>
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: "100px" }}>Order #</th>
                              <th style={{ width: "140px" }}>Date</th>
                              <th>Customer</th>
                              <th>Items</th>
                              <th style={{ width: "80px" }}>Type</th>
                              <th style={{ width: "80px" }}>Amount</th>
                              <th style={{ width: "100px" }}>Status</th>
                              <th style={{ width: "100px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((order, index) => (
                              <tr
                                key={order._id || index}
                                onClick={() => this.viewOrderDetail(order)}
                                style={{ cursor: "pointer" }}
                                className="order-row"
                              >
                                <td>
                                  <code style={{ fontSize: "11px" }}>
                                    {order.orderNumber || `#${order._id?.slice(-6).toUpperCase()}`}
                                  </code>
                                </td>
                                <td>
                                  <small>{order.createdAt}</small>
                                </td>
                                <td>
                                  <div>{order.username || "N/A"}</div>
                                  <small className="text-muted">{order.mobile}</small>
                                </td>
                                <td>
                                  <div style={{
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                  }} title={order.food}>
                                    {order.food || "N/A"}
                                  </div>
                                </td>
                                <td>
                                  <small>{this.getOrderTypeLabel(order.orderPlacetype)}</small>
                                </td>
                                <td>
                                  <strong>${(order.total || 0).toFixed(2)}</strong>
                                </td>
                                <td>
                                  {this.getStatusBadge(order)}
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  {this.renderActionButton(order)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <Row className="mt-3">
                        <Col md={6}>
                          <span className="text-muted">
                            Page {currentPage} of {totalPages}
                          </span>
                        </Col>
                        <Col md={6}>
                          <div className="d-flex justify-content-end align-items-center">
                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage <= 1}
                              onClick={() => this.getALllorder(currentPage - 1)}
                              className="mr-1"
                            >
                              Prev
                            </Button>

                            {/* Page numbers */}
                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                              let pageNum;
                              if (totalPages <= 5) {
                                pageNum = i + 1;
                              } else if (currentPage <= 3) {
                                pageNum = i + 1;
                              } else if (currentPage >= totalPages - 2) {
                                pageNum = totalPages - 4 + i;
                              } else {
                                pageNum = currentPage - 2 + i;
                              }
                              return (
                                <Button
                                  key={pageNum}
                                  color={currentPage === pageNum ? "primary" : "light"}
                                  size="sm"
                                  className="mr-1"
                                  onClick={() => this.getALllorder(pageNum)}
                                >
                                  {pageNum}
                                </Button>
                              );
                            })}

                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage >= totalPages}
                              onClick={() => this.getALllorder(currentPage + 1)}
                              className="mr-2"
                            >
                              Next
                            </Button>

                            <Input
                              type="select"
                              value={limit}
                              onChange={(e) => {
                                this.setState({ limit: parseInt(e.target.value) }, () => {
                                  this.getALllorder(1);
                                });
                              }}
                              style={{ width: "70px" }}
                              bsSize="sm"
                            >
                              <option value={10}>10</option>
                              <option value={15}>15</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                            </Input>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastContainer />

        <style jsx>{`
          .order-row:hover {
            background-color: #f8f9fa !important;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default FoodOrder;
